<script>
    import Fa from 'svelte-fa';
    import { faChevronRight, faCircle } from '@fortawesome/pro-regular-svg-icons';
    import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

    import { getContext } from 'svelte';

    export let key;
    export let showIcon = true;
    export let accordianOpen = false;
    export let iconType = '';

    // Get context from store fro accordian <Accordian>
    const store = getContext('svelte-collapsible-accordion');
    $: params = {
        open: $store.key === key
    };

    // if an item is set to open on default
    $: if (accordianOpen) {
        store.update((s) => Object.assign(s, { key }));
    }

    // handle accordian toggle
    const handleToggle = () => {
        if (params.open) {
            store.update((s) => Object.assign(s, { key: null }));
        } else {
            store.update((s) => Object.assign(s, { key }));
        }
    };
</script>

<button class="w-full" on:click={() => handleToggle()}>
    <div class="flex items-center">
        <div class="w-full text-left">
            <slot name="header" />
        </div>
        {#if showIcon}
            <div class="absolute right-0 text-right">
                {#if iconType === 'Radio'}
                    {#if params.open}
                        <Fa icon={faCircleCheck} class="inline-block text-primary dark:text-purple-300" />
                    {:else}
                        <Fa icon={faCircle} class="inline-block" />
                    {/if}
                {:else}
                    <Fa icon={faChevronRight} class="inline-block" rotate={params.open ? 90 : 0} />
                {/if}
            </div>
        {/if}
    </div>
</button>

<div
    class={`w-full transition-all duration-500 ease-in-out
        ${params.open ? 'opacity-1 no-scrollbar visible max-h-[100rem] overflow-y-scroll' : 'invisible max-h-0 opacity-0'}`}
>
    <slot name="body" />
</div>
